import type { CreateScheduledReportExportRequest } from '~/server_shared/openapi/data-contracts';

export type DayOfWeek = NonNullable<CreateScheduledReportExportRequest['export_days']>[number];
export const DAY_OPTIONS: readonly DayOfWeek[] = ['0', '1', '2', '3', '4', '5', '6'] as const;
